<template>
  <div class="product is-gray">
    <div class="image d-flex align-items-center justify-content-center">
      <a :href="getUrl(item)">
        <img
          :src="item.image"
          :alt="localize(item.names)"
          class="img-fluid"
          onerror="this.src = '/images/comingsoon.png'"
          style="max-height: 220px"
        />
      </a>
      <div
        class="hover-overlay d-flex align-items-center justify-content-center"
      >
        <div class="CTA d-flex align-items-center justify-content-center">
          <!--<a class="add-to-cart"><i class="fa fa-shopping-cart"></i></a>-->
          <a :href="getUrl(item)" class="visit-product active"
            ><i class="icon-search"></i>{{ $t('View') }}</a
          >
          <!--<a data-toggle="modal" data-target="#exampleModal" class="quick-view"><i class="fa fa-arrows-alt"></i></a>-->
        </div>
      </div>
    </div>
    <div class="title">
      <a :href="getUrl(item)">
        <h3 class="h6 text-uppercase no-margin-bottom">
          {{ localize(item.names) }}
        </h3>
      </a>
      <span class="price text-muted">
        {{ $t('Starting at') }}
        <s
          v-if="
            item.minimumRetailPrice.amount !== item.minimumFinalPrice.amount
          "
          >{{ asCurrency(item.minimumRetailPrice.amount) }}
          <small v-if="currency !== displayCurrency"
            ><s
              >{{ asDisplayCurrency(item.minimumRetailPrice.amount)
              }}<sup>1</sup></s
            ></small
          ></s
        >
        {{ asCurrency(item.minimumFinalPrice.amount) }}
        <small v-if="currency !== displayCurrency"
          >{{ asDisplayCurrency(item.minimumFinalPrice.amount)
          }}<sup>1</sup></small
        >
      </span>
    </div>
  </div>
</template>

<script setup lang="ts">
import { localize as genLocalize } from '../common/localize';
import { asCurrency as asCurrencyFn, asDisplayCurrency as asDisplayCurrencyFn } from '../common/currency';
import { type PrintWithStyle } from '../common/CatalogItem';

const props = defineProps<{
  item?: PrintWithStyle;
  culture?: string;
  currency?: string;
  displayCurrency?: string;
  displayExchangeRate?: number;
  blobDomain?: string;
}>();

function getUrl(item: PrintWithStyle): string {
  return '/noncustom/item/' + item.id + '/' + item.styleId;
}

function asCurrency(amount: number): string {
  return asCurrencyFn(props.currency, amount);
}

function asDisplayCurrency(amount: number): string {
  return asDisplayCurrencyFn(props.displayExchangeRate, props.displayCurrency, amount);
}

function localize(dict: Record<string, string>) {
  return genLocalize(props.culture, dict);
}
</script>

<style scoped></style>
